module.exports = __webpack_public_path__ + "static/WelcomeToElk2-0b1455625480a3bfcd85192c38ce0ac3.webp";